/**
 * Custom Subscription Widget JavaScript
 * Handles radio selection, visual updates, and integration with bundle builder
 */

class CustomSubscriptionWidget {
  constructor() {
    this.widget = document.querySelector(".custom-subscription-widget");
    if (!this.widget) return;

    this.options = this.widget.querySelectorAll(".subscription-option");
    this.radios = this.widget.querySelectorAll(".subscription-radio");

    this.init();
  }

  init() {
    // Inject shipping information into options
    this.injectShippingInfo();

    // Set up click handlers for label selection
    this.options.forEach((option) => {
      option.addEventListener("click", (e) => {
        // Don't trigger if clicking on the radio directly
        if (e.target.classList.contains("subscription-radio")) return;

        const radio = option.querySelector(".subscription-radio");
        if (radio) {
          radio.checked = true;
          this.handleSelectionChange(radio);
        }
      });
    });

    // Set up change handlers for radio inputs
    this.radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.handleSelectionChange(radio);
      });
    });

    // Initialize first selected option
    const checkedRadio = this.widget.querySelector(
      ".subscription-radio:checked",
    );
    if (checkedRadio) {
      this.updateSelection(checkedRadio);
    }
  }

  injectShippingInfo() {
    // Get shipping info divs
    const shippingDiv = document.querySelector(".shipping_purchase");
    const shippingOneTimeDiv = document.querySelector(
      ".shipping-one-time-purchase",
    );
    console.log("333");

    if (!shippingDiv && !shippingOneTimeDiv) return;

    // Inject shipping info into each option
    this.options.forEach((option) => {
      const radio = option.querySelector(".subscription-radio");
      if (!radio) return;

      const radioType = radio.dataset.radioType;

      // For subscription plans, add subscription shipping info
      if (radioType === "selling_plan" && shippingDiv) {
        console.log(this.options);

        const shippingContent = document.createElement("div");
        shippingContent.className = "subscription-shipping-info";
        shippingContent.innerHTML = shippingDiv.innerHTML;
        option.appendChild(shippingContent);
      }
      // For one-time purchase, add one-time shipping info
      else if (radioType === "one_time_purchase" && shippingOneTimeDiv) {
        const shippingContent = document.createElement("div");
        shippingContent.className = "subscription-shipping-info";
        shippingContent.innerHTML = shippingOneTimeDiv.innerHTML;
        option.appendChild(shippingContent);
      }
    });
  }

  handleSelectionChange(radio) {
    // Update visual selection
    this.updateSelection(radio);

    // Trigger bundle builder price update if it exists
    // Pass true to skip widget price update (prices already correct in widget)
    if (window.bundleBuilderInstance) {
      window.bundleBuilderInstance.updateTierPrices();
      window.bundleBuilderInstance.updateBundle(true);
    }

    // Dispatch custom event for other listeners
    const event = new CustomEvent("subscription-changed", {
      detail: {
        sellingPlanId: radio.value,
        radioType: radio.dataset.radioType,
        price: radio.dataset.priceDiscount,
      },
    });
    document.dispatchEvent(event);
  }

  updateSelection(selectedRadio) {
    if (!this.radios) return;
    // Update all radio buttons and their parent labels
    this.radios.forEach((radio) => {
      const option = radio.closest(".subscription-option");
      if (option) {
        if (radio === selectedRadio) {
          option.classList.add("subscription-option--selected");
        } else {
          option.classList.remove("subscription-option--selected");
        }
      }
    });
  }

  getSelectedPlan() {
    if (!this.widget) return null;
    const checkedRadio = this.widget.querySelector(
      ".subscription-radio:checked",
    );
    if (!checkedRadio) return null;

    return {
      sellingPlanId: checkedRadio.value,
      radioType: checkedRadio.dataset.radioType,
      price: checkedRadio.dataset.priceDiscount,
      variantPrice: checkedRadio.dataset.variantPrice,
    };
  }

  updatePrices(tierPrice, basePrice) {
    if (!this.options) return;
    // Update prices for all subscription options
    this.options.forEach((option) => {
      const radio = option.querySelector(".subscription-radio");
      const priceEl = option.querySelector(".subscription-price");

      if (!radio || !priceEl) return;

      const radioType = radio.dataset.radioType;
      const variantPrice = radio.dataset.variantPrice;
      const dataPriceDiscount = parseFloat(radio.dataset.priceDiscount) / 100; // Convert cents to dollars
      const dataBasePrice = parseFloat(radio.dataset.basePrice) / 100; // Convert cents to dollars

      if (radioType === "one_time_purchase") {
        // One-time purchase uses tier price directly
        priceEl.textContent = `$${tierPrice.toFixed(2)}/ea`;
      } else {
        // Subscription: calculate discount ratio from original prices
        // Then apply same ratio to tier price
        const discountRatio = dataPriceDiscount / dataBasePrice;
        const finalPrice = tierPrice * discountRatio;
        priceEl.textContent = `$${finalPrice.toFixed(2)}/ea`;
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  const subscriptionWidget = new CustomSubscriptionWidget();

  // Make it globally accessible if needed
  window.subscriptionWidget = subscriptionWidget;
});

// Also expose the class for manual initialization
window.CustomSubscriptionWidget = CustomSubscriptionWidget;
